import React from 'react'
import PropTypes from 'prop-types'
import ZoomIn from '@material-ui/icons/Add'
import ZoomOut from '@material-ui/icons/Remove'
import {
  makeStyles,
  Button,
  Slider
} from '@material-ui/core'

const sliderWidth = 64

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: sliderWidth,
    height: '50vh',
    position: 'absolute',
    right: theme.spacing(3),
    top: 0,
    bottom: 0,
    margin: 'auto',
    pointerEvents: 'all',
    border: '1px solid',
    background: theme.palette.background.paper,
    borderColor: theme.palette.divider,
    borderBottomColor: theme.palette.primary.light,
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('sm')]: {
      height: 112,
      width: 56,
      bottom: 24,
      top: 'auto'
    }
  },
  button: {
    minWidth: sliderWidth,
    minHeight: sliderWidth,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      minWidth: 56,
      minHeight: 56
    }
  },
  sliderContainer: {
    flex: 1,
    padding: `${theme.spacing(3)}px 0`,
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: sliderWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  sliderRoot: {
    margin: `1px 0`,
    '&.MuiSlider-vertical': {
      padding: `0px 32px`
    }
  },
  sliderRail: {
    background: theme.palette.divider
  },
  sliderThumb: {
    background: '#fff'
  },
  sliderTrack: {
    background: '#fff'
  },
  sliderMark: {
    width: 10,
    transform: 'translateX(-4px)',
    color: theme.palette.grey[700],
    '&:first-of-type': {
      display: 'none'
    }
  }
}))

const ZoomSlider = ({ onZoomIn, onZoomOut, ...props }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Button
        classes={{ root: classes.button }}
        onClick={onZoomIn}>
        <ZoomIn />
      </Button>
      <div className={classes.sliderContainer}>
        <Slider
          track={false}
          valueLabelDisplay="off"
          classes={{
            root: classes.sliderRoot,
            track: classes.sliderTrack,
            rail: classes.sliderRail,
            thumb: classes.sliderThumb,
            mark: classes.sliderMark
          }}
          {...props}
        />
      </div>
      <Button
        classes={{ root: classes.button }}
        onClick={onZoomOut}>
        <ZoomOut />
      </Button>
    </div>
  )
}

ZoomSlider.propTypes = {
  onZoomIn: PropTypes.func,
  onZoomOut: PropTypes.func
}

export default ZoomSlider
